import { render } from "./tour-status.vue?vue&type=template&id=10972a37&scoped=true"
import script from "./tour-status.vue?vue&type=script&lang=js"
export * from "./tour-status.vue?vue&type=script&lang=js"

import "./tour-status.vue?vue&type=style&index=0&id=10972a37&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10972a37"]])

export default __exports__